import {
  ADD_MENTOR_DATA,
  ADD_ALUMNI_INFO,
  CLEAR_CONNECT,
  ADD_PROFILE_ID,
  ADD_WEBINAR
} from "./actions";

const initialState = {
  mentors:[],
  profileId:'',
  alumniProfile:[],
  alumniProfileType:'',
  myMentors:[],
  alumnis:[],
  myAlumnis:[],
  alumniRequests:[],
  scholars:[],
  myScholars:[],
  scholarRequests:[],
  webinar:'',
  notifications:[]
};

const ConnectReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_MENTOR_DATA:
      let data = state;
      data[action.data.type] =[...action.data.value]
     
      return {
        ...data,
      };
    case ADD_ALUMNI_INFO:
        let  alumniProfileType= state.alumniProfileType;
        // data[action.data.type] = action.data.value;
        // for(let i in action.data){
          alumniProfileType = action.data;
        // }
        return {
          ...state,
          alumniProfileType: alumniProfileType
        };
        case ADD_WEBINAR:
          let  webinar= state.webinar;
          // data[action.data.type] = action.data.value;
          // for(let i in action.data){
          webinar= action.data;
          // }
          return {
            ...state,
            webinar:webinar,
          };
         
      case ADD_PROFILE_ID:
        let id = state.profileId;
        // data[action.data.type] = action.data.value;
        // for(let i in action.data){
        id = action.data;
        // }
        return {
          ...state,
          profileId: id,
        };
        case CLEAR_CONNECT:
          // let data2 = state.tokens;
          // data2.token = "";
          // data2.refreshToken = "";
          return initialState;
      default:
      return state;
  }
};
export default ConnectReducer;
